<!-- VA 提现操作指南 -->
<template>
  <div class="withdraw-operation-manual">
    <h2 class="title">
      <b>{{ $t('components.wthdrawManual.title') }}</b>
    </h2>
    <div class="content">
      <div class="step-wrap">
        <p class="step-title">
          <b>{{ $t('components.wthdrawManual.tips1') }}</b>
        </p>
        <img src="../../../static/imgs/WthdrawOperationManual/doc/1.png">
      </div>
      <div class="step-wrap">
        <p class="step-title">
          <b>{{ $t('components.wthdrawManual.tips2') }}</b>
        </p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips3') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips4') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips5') }}</p>
      </div>

      <div class="step-wrap">
        <p class="step-title">
          <b>{{ $t('components.wthdrawManual.tips6') }}</b>
        </p>
        <p class="sub-title" style="padding-top:20px;">{{ $t('components.wthdrawManual.tips7') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips8') }}</p>
        <img src="../../../static/imgs/WthdrawOperationManual/doc/2.png">
        <p class="step-desc">{{ $t('components.wthdrawManual.tips9') }}</p>
        <img src="../../../static/imgs/WthdrawOperationManual/doc/3.png">
        <p class="step-desc">{{ $t('components.wthdrawManual.tips10') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips11') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips12') }}</p>
        <div>
          <img src="../../../static/imgs/WthdrawOperationManual/doc/4.png">
          <img src="../../../static/imgs/WthdrawOperationManual/doc/5.png">
        </div>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips13') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips14') }}</p>
        <img src="../../../static/imgs/WthdrawOperationManual/doc/6.png">
        <p class="sub-title" style="padding-top:20px;">{{ $t('components.wthdrawManual.tips15') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips16') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips17') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips18') }}</p>
      </div>

      <div class="step-wrap">
        <p class="step-title">
          <b>{{ $t('components.wthdrawManual.tips19') }}</b>
        </p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips20') }}</p>
      </div>

      <div class="step-wrap">
        <p class="step-title">
          <b>{{ $t('components.wthdrawManual.tips21') }}</b>
        </p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips22') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips23') }}</p>
        <img src="../../../static/imgs/WthdrawOperationManual/doc/7.png">
        <img src="../../../static/imgs/WthdrawOperationManual/doc/8.png">
      </div>

      <div class="step-wrap">
        <p class="step-title">
          <b>{{ $t('components.wthdrawManual.tips24') }}</b>
        </p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips25') }}</p>
        <p class="sub-title">{{ $t('components.wthdrawManual.tips26') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips27') }}</p>
        <img src="../../../static/imgs/WthdrawOperationManual/doc/9.png">
      </div>

      <div class="step-wrap">
        <p class="step-title"><b>{{ $t('components.wthdrawManual.tips28') }}</b></p>
        <p class="sub-title">{{ $t('components.wthdrawManual.tips29') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips30') }}</p>
        <img src="../../../static/imgs/WthdrawOperationManual/doc/10.png">
        <p class="sub-title">{{ $t('components.wthdrawManual.tips31') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips32') }}</p>
        <img src="../../../static/imgs/WthdrawOperationManual/doc/11.png">
        <img src="../../../static/imgs/WthdrawOperationManual/doc/12.png">
        <p class="step-desc">{{ $t('components.wthdrawManual.tips33') }}</p>
        <img src="../../../static/imgs/WthdrawOperationManual/doc/13.png">
        <img src="../../../static/imgs/WthdrawOperationManual/doc/14.png">
        <p class="step-desc">{{ $t('components.wthdrawManual.tips34') }}</p>
        <img src="../../../static/imgs/WthdrawOperationManual/doc/15.png">
      </div>

      <div class="step-wrap">
        <p class="step-title">
          <b>{{ $t('components.wthdrawManual.tips35') }}</b>
        </p>
        <p class="sub-title">{{ $t('components.wthdrawManual.tips36') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips37') }}</p>
        <p class="sub-title">{{ $t('components.wthdrawManual.tips38') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips39') }}</p>
        <p class="sub-title">{{ $t('components.wthdrawManual.tips40') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips41') }}</p>
        <p class="sub-title">{{ $t('components.wthdrawManual.tips42') }}</p>
        <p class="step-desc">{{ $t('components.wthdrawManual.tips43') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WithdrawOperationManual',
  components: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang='scss' scoped>
.withdraw-operation-manual {
	width: 1192px;
	background-color: #fff;
	margin: 18px auto 0;
	padding: 30px;
	.title {
		text-align: center;
		font-size: 18px;
		border-bottom: 1px solid #efefef;
		padding-bottom: 30px;
		font-weight: bold;
	}
	.content {
		padding-top: 20px;
		.step-wrap {
			padding-bottom: 30px;
			.step-title {
				font-size: 16px;
				padding-bottom: 10px;
			}
			.sub-title {
				font-size: 13px;
				font-weight: bold;
				padding-bottom: 10px;
				// padding-top: 20px;
			}
			.step-desc {
				color: #606266;
				padding-bottom: 14px;
				font-size: 13px;
			}
			.step-desc-middle {
				padding: 30px 0 10px;
				color: #606266;
				padding-bottom: 14px;
				font-size: 13px;
			}
			.big-img {
				display: block;
				// margin-bottom: 20px;
				// padding-bottom: 20px;
				// background-image: url("./img/1.png");
			}
		}
	}
}
</style>
